const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  apiKey: process.env.REACT_APP_API_KEY,
  useMocks: process.env.REACT_APP_USE_MOCKS === 'true',
};

export default config;
